import { reactive } from 'vue';
import Api from '../api/Chat';

const state = reactive({
    activeTab: true,
    loading: false,
    loadingConversation: false,
    sending: false,
    conversations: [],
    messages: [],
    active: null,
    office: null,
    teachers: [],
    timeout: 5000,
    refreshCount: 0,
    status: '',
    isApp: false,
    hashedKey: '',
    user: {
        name: null,
        image: null,
    }
});

export default {
    async init () {
        this.addActiveTabListener();
        state.loading = true;
        state.loadingConversation = true;
        
        const res = await Api.Get()

        state.loading = false;
        state.loadingConversation = false;
        state.office = res.data.office;
        state.teachers = res.data.teachers;
        state.conversations = res.data.conversations;
        state.studentId = res.data.student_id;
        state.contactId = res.data.contact_id;
        state.user = res.data.user;
        state.isApp = res.data.is_app;
        state.hashedKey = res.data.hashed_key;

        this.refreshMessagesWithTimeout();
    },
    refreshMessagesWithTimeout () {
        state.refreshCount++;
        if (state.refreshCount > 10) {
            // After 10 refreshes without interaction, we reduce refresh interval
            state.timeout = 10000;
        }

        const _this = this;
        setTimeout(function () {
            if (_this.isSending() || !state.activeTab) {
                return _this.refreshMessagesWithTimeout();
            }

            _this.refreshMessages(_this.refreshMessagesWithTimeout())
        }, state.timeout);
    },
    refreshMessages (callback) {
        const lastMessage = this.getActiveConversationLastMessage();
        Api.Refresh(this.getActiveConversationId(), lastMessage ? lastMessage.id : null).then(res => {
            if (res.data.student_id !== state.studentId || res.data.contact_id !== state.contactId) {
                return; // No longer authed as the same user, stop refreshing
            }
            state.conversations = res.data.conversations;
            if (this.isSending() && typeof callback === 'function') {
                return callback();
            }
            this.updateMessages(res.data.messages);
            if (typeof callback === 'function') {
                callback();
            }
        });
    },
    sendMessage(text) {
        this.resetRefreshCount();
        state.sending = true;
        const lastMessage = this.getActiveConversationLastMessage();
        return Api.Post(state.active.id, lastMessage ? lastMessage.id : null, text).then(res => {
            state.conversations = res.data.conversations;
            this.updateMessages(res.data.messages);
            state.sending = false;
        }).catch(() => {
            state.sending = false;
        })
    },
    setMessages(messages) {
        state.messages = messages.sort((a, b) => {
            return a.id - b.id;
        });
        state.active.last_message = state.messages[state.messages.length - 1];
    },
    updateMessages(newMessages) {
        const lastMessage = this.getActiveConversationLastMessage();
        if (newMessages.length &&
            (!lastMessage || newMessages[0].id > lastMessage.id) &&
            newMessages[0].conversation_id === state.active.id)
        {
            this.setMessages(state.messages.concat(newMessages));
        }
    },
    getOffice() {
        return state.office;
    },
    isLoading () {
        return state.loading;
    },
    isLoadingConversation () {
        return state.loadingConversation;
    },
    isSending () {
        return state.sending;
    },
    loadConversation (conversation) {
        this.resetRefreshCount();
        state.active = conversation;
        state.status = '';

        state.loadingConversation = true;
        return Api.Get(conversation.id).then(res => {
            if (conversation.id !== state.active.id) {
                // conversation changed, throw away this result
                return
            }
            this.setMessages(res.data.messages);
            state.status = res.data.status;
            state.loadingConversation = false;
        })
    },
    getTeacher (teacherId) {
        return state.teachers.find(teacher => {
            return teacher.user_id === teacherId;
        });
    },
    getUser() {
        return state.user;
    },
    getActiveConversation () {
        return state.active;
    },
    getActiveConversationId () {
        return this.getActiveConversation() ? this.getActiveConversation().id : null;
    },
    getActiveConversationLastMessage () {
        return this.getActiveConversation() ? this.getActiveConversation().last_message : null;
    },
    getMessages() {
        return state.messages;
    },
    resetActiveConversation() {
        state.messages= [];
        state.active = null;
    },
    resetRefreshCount() {
        state.refreshCount = 0;
        state.timeout = 5000;
    },
    isApp() {
        return state.isApp;
    },
    getHashedKey() {
        return state.hashedKey;
    },
    getConversations() {
        return state.conversations;
    },
    getConversationStatus() {
        return state.status;
    },
    addActiveTabListener() {
        document.onvisibilitychange = function() {
            state.activeTab = !document.hidden
        }
    },
}
